<div class="d-flex flex-row flex-auto flex-nowrap campaign-item">
  <div class="d-flex flex-g1">
    <div class="d-flex flex-row flex-auto campaign-content-wrapper">
      <div class="d-flex campaign-info">
        <div class="d-flex flex-row flex-auto flex-nowrap campaign-selection" (click)="selectCampaign(campaign)">
          <div class="d-none d-md-flex">
            <div class="d-flex flex-row flex-auto align-items-center justify-content-center campaign-influencer-icon">
              <a *ngIf="campaign.is_expanded" class="icon-select"></a>
              <a *ngIf="!campaign.is_expanded"
                 class="icon-details"
                 placement="bottom"
                 ngbTooltip="{{'info_box.campaign.expand_icon' | translate}}"><img src="/assets/images/Details_Icon.svg" /></a>
            </div>
          </div>
          <div class="d-flex flex-auto align-items-center campaign-info-wrapper">
            <div class="d-flex flex-column flex-auto justify-content-start full-width">
              <div class="campaign-name">
                {{campaign.name}}
              </div>
              <div class="campaign-type">
                {{campaign.typeName}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-md-flex campaign-total-influencers" (click)="selectCampaign(campaign)">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-start">
          <div class="campaign-border-left"></div>
          <span class="text-light-font campaign-number" *ngIf="!campaign.isFetchingKpi">{{secondColData}}</span>
          <span class="text-light-font campaign-number" *ngIf="campaign.isFetchingKpi"><achoo-loader [textPlaceholder]="true"></achoo-loader></span>
        </div>
      </div>
      <div class="d-none d-md-flex campaign-total-posts" (click)="selectCampaign(campaign)">
        <div class="d-flex flex-row flex-auto flex-nowrap align-items-center justify-content-start">
          <div class="campaign-border-left"></div>
          <div class="text-light-font campaign-number post-count" *ngIf="!campaign.isFetchingKpi">
            <div>{{getInfluencerPostCount(campaign)}}</div>
            <div class="new-published-post" *ngIf="campaign.newPosts > 0">{{'campaigns.new_posts' | translate:{new_post_count: campaign.newPosts} }}</div>
          </div>
          <span class="text-light-font campaign-number" *ngIf="campaign.isFetchingKpi"><achoo-loader [textPlaceholder]="true"></achoo-loader></span>
        </div>
      </div>
      <div class="d-none d-md-flex campaign-reach" (click)="selectCampaign(campaign)">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-start">
          <div class="campaign-border-left"></div>
          <span class="text-light-font campaign-number" *ngIf="!campaign.isFetchingKpi">{{ normalizeNumberData(campaign.reach) }}</span>
          <span class="text-light-font campaign-number" *ngIf="campaign.isFetchingKpi"><achoo-loader [textPlaceholder]="true"></achoo-loader></span>
        </div>
      </div>
      <div class="d-none d-md-flex campaign-engagement" (click)="selectCampaign(campaign)">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-start">
          <div class="campaign-border-left"></div>
          <span class="text-light-font campaign-number" *ngIf="!campaign.isFetchingKpi">{{ normalizeNumberData(campaign.engagement) }}</span>
          <span class="text-light-font campaign-number" *ngIf="campaign.isFetchingKpi"><achoo-loader [textPlaceholder]="true"></achoo-loader></span>
        </div>
      </div>
      <div class="d-none d-md-flex campaign-impact-percent" (click)="selectCampaign(campaign)">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-start">
          <div class="campaign-border-left"></div>
          <span class="text-light-font campaign-number" *ngIf="!campaign.isFetchingKpi">{{ normalizeNumberData(campaign.impact * 100) | percentNumberSuffix }}</span>
          <span class="text-light-font campaign-number" *ngIf="campaign.isFetchingKpi"><achoo-loader [textPlaceholder]="true"></achoo-loader></span>
        </div>
      </div>
      <div class="d-none d-md-flex campaign-button-group">
        <div class="d-flex flex-row flex-auto align-items-center action-group">
          <div class="button-icon" *ngIf="!enableInfluencerPlatform"
                [ngClass]="{'hidden-icon-add': isCampaignHistory}">
            <a class="icon-add" *ngIf="!isCampaignHistory"
               actionByLevels="Create Campaign"
               [wallName]="'Campaigns Disabled'"
               (afterChecking)="openAddInfluencer($event)"></a>
          </div>
          <div class="button-icon" *ngIf="!enableInfluencerPlatform">
            <a class="icon-analytics" (click)="openMeasurePage($event)"></a>
          </div>
          <div class="button-icon button-delete">
            <a class="icon-delete" *ngIf="canDeleteCampaign"
               actionByLevels="Create Campaign"
               [wallName]="'Campaigns Disabled'"
               (afterChecking)="deleteCampaign(campaign)"></a>
          </div>
          <div class="button-icon">
            <a class="icon-edit" (click)="openCampaignDetails(campaign.id, campaign.campaignInfluencerId)"></a>
          </div>
        </div>
      </div>
      <div class="d-flex d-md-none align-items-center campaign-mobile-detail">
        <div class="d-flex flex-row flex-auto align-items-center justify-content-center">
          <button type="button" [ngClass]="['button', getCampaignDetailButtonColorClass(campaign)]" (click)="openCampaignDetails(campaign.id, campaign.campaignInfluencerId, true)">{{buttonLabel | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="campaign-influencer-loading" *ngIf="campaign.is_expanded && campaign.isFetchingKpi">
  <achoo-loader [normalPlaceholder]="true"></achoo-loader>
</div>
<campaign-influencers-list *ngIf="!enableInfluencerPlatform"
  [isShow]="campaign.is_expanded && !campaign.isFetchingKpi"
  [campaignId]="campaign.id"
  [influencerList] = "influencerList"
  [campaignName]="campaign.name"
  [campaignTotalPost]="campaign.numberOfPosts"
  [isCampaignInfluencerDetails]="isCampaignInfluencerDetails"
  (goToCampaignDetails)="requestGoToCampaignDetails()"
></campaign-influencers-list>
<campaign-post-list class="d-none d-md-block" *ngIf="enableInfluencerPlatform"
                    [isShow]="campaign.is_expanded && !campaign.isFetchingKpi"
                    [campaignId]="campaign.id"
                    [postList]="postList"
></campaign-post-list>



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-item/campaign-item.component.html